import { cn } from '@/utils'

export interface SegmentedOption<Value extends string> {
  value: Value
  label: string
}

interface SegmentedControlProps<Value extends string> {
  options: SegmentedOption<Value>[]
  value: Value
  onChange: (value: Value) => void
  ariaLabel?: string
}

// Text only on purpose: report exports grab the first svg inside a chart's
// figure, so an icon here would be captured instead of the chart.
export const SegmentedControl = <Value extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: SegmentedControlProps<Value>) => (
  <fieldset
    aria-label={ariaLabel}
    className="inline-flex items-center gap-0.5 rounded-md bg-blue-1 p-0.5"
  >
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        aria-pressed={value === option.value}
        onClick={() => onChange(option.value)}
        className={cn(
          'cursor-pointer rounded px-2.5 py-1 text-xs font-medium transition-colors',
          value === option.value
            ? 'bg-white text-blue-7 shadow-sm'
            : 'text-blue-5 hover:text-blue-7',
        )}
      >
        {option.label}
      </button>
    ))}
  </fieldset>
)
